import { Box, FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const AjustesYApoyos = () => {
  const { promptData, setPromptData} = useActividadesContext();
  

  const handleTema = (event) => {
    const necesidades_educativas = event.target.value;
   
    setPromptData((prevData) => ({
        ...prevData,
        necesidades_educativas: necesidades_educativas 
      }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <Box>
      <Box sx={{ display: 'flex', flexDirection: 'column',  }}>
        <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color:'#336B87' }}>
        Ajustes y apoyos requeridos
        </Typography>
        <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>Detalla las características de tus estudiantes que deben ser consideradas. </FormLabel>
       
        </Box>
        <TextField
          fullWidth
          variant="outlined"
          value={promptData.necesidades_educativas}
          placeholder="Escribe aquí los ajustes y apoyos requeridos. Ejemplo: Una estudiante con dislexia"
          onChange={handleTema}
          InputProps={{
            sx: {
                mt:1,
                mb: 3,
                fontFamily: 'montserrat',
                fontSize: '0.75rem',
                color: '#005559',
                '&::placeholder': {
                    color: '#005559',

                },
                '&:before': {
                    borderBottomColor: '#005559',

                },
                '&:after': {
                    borderBottomColor: '#005559',
                },
            }
        }}
        />
      </Box>
    </Grid>
  );
};

export default AjustesYApoyos;
